// extracted by mini-css-extract-plugin
export default {"badge":"PendingBadge_badge__x5QXv"};